<template>
  <crud-modal
    :title="$t('components.company.theme.updateColorsTitle')"
    action="update"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <div class="flex flex-wrap mb-6">
      <div class="w-full mb-2">
        <label>{{ $t('components.company.theme.primary') }}:</label>
        <div class="flex items-stretch w-full">
          <div class="w-1/2">
            <input-text-validated
              ref="colorsModel.primary"
              v-model="colorsModel.primary"
              input-class="w-full"
              rules="required|hexcolor"
            />
          </div>
          <div
            class="w-1/2 ml-2 rounded"
            :style="{ background: colorsModel.primary }"
          />
        </div>
        <div class="mt-4">
          <contrast-indicator
            :selected-color="colorsModel.primary"
            :has-sufficient-contrast="hasPrimarySufficientContrast"
          />
        </div>
      </div>

      <div class="w-full mb-2">
        <label>{{ $t('components.company.theme.secondary') }}:</label>
        <div class="flex items-stretch w-full">
          <div class="w-1/2">
            <input-text-validated
              ref="colorsModel.secondary"
              v-model="colorsModel.secondary"
              input-class="w-full"
              rules="required|hexcolor"
            />
          </div>
          <div
            class="w-1/2 ml-2 rounded"
            :style="{ background: colorsModel.secondary }"
          />
        </div>
        <div class="mt-4">
          <contrast-indicator
            :selected-color="colorsModel.secondary"
            :has-sufficient-contrast="hasSecondarySufficientContrast"
          />
        </div>
      </div>
    </div>
  </crud-modal>
</template>

<script>
import UPDATE_COMPANY_THEME from '@/graphql/UpdateCompanyTheme.gql'
import GET_COMPANY from '@/graphql/GetCompany.gql'
import InputTextValidated from '@/components/form/text-validated'
import CrudModal from '@/components/modals/crud-modal'
import ContrastIndicator from './contrast-indicator.vue'
import { meetsAA } from '@/lib/color-contrast'

export default {
  components: {
    InputTextValidated,
    CrudModal,
    ContrastIndicator
  },
  props: {
    companyId: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      colorsModel: {
        primary: '',
        secondary: ''
      }
    }
  },
  computed: {
    hasPrimarySufficientContrast () {
      return meetsAA(this.colorsModel.primary)
    },
    hasSecondarySufficientContrast () {
      return meetsAA(this.colorsModel.secondary)
    }
  },
  created () {
    this.colorsModel = { ...this.colors }
  },
  methods: {
    async submit () {
      await this.$apollo.mutate({
        mutation: UPDATE_COMPANY_THEME,
        variables: {
          input: {
            companyId: this.companyId,
            colors: {
              primary: this.colorsModel.primary,
              secondary: this.colorsModel.secondary
            }
          }
        },
        refetchQueries: [{ query: GET_COMPANY, variables: { id: this.companyId } }]
      })
    }
  }
}
</script>
